module.exports = __webpack_public_path__ + "img/1.b724d398.jpg";